const TOKEN_KEY = "vanta_token";

let memoryToken = null;

export const tokenStore = {
  get: () => {
    if (memoryToken) return memoryToken;
    try {
      const stored = localStorage.getItem(TOKEN_KEY);
      if (stored) {
        memoryToken = stored;
        return stored;
      }
      // Compatibilité : un jeton posé par une version précédente du site (qui utilisait
      // sessionStorage, effacé à chaque fermeture d'onglet) est repris et migré ici.
      const legacy = sessionStorage.getItem(TOKEN_KEY);
      if (legacy) {
        localStorage.setItem(TOKEN_KEY, legacy);
        sessionStorage.removeItem(TOKEN_KEY);
        memoryToken = legacy;
        return legacy;
      }
      return null;
    } catch {
      return null;
    }
  },
  set: (token) => {
    memoryToken = token;
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch { /* ignore */ }
  },
  remove: () => {
    memoryToken = null;
    try {
      localStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(TOKEN_KEY);
    } catch { /* ignore */ }
  }
};

export const authHeader = () => {
  const token = tokenStore.get();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
